import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 57 — GoHighLevel hiring-decision cluster service links.
 *
 * Every Batch 57 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch57Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH57_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-hire-red-flags": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /candidate who lists GoHighLevel on a profile is not a vetted specialist who can architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "fractional-gohighlevel-architect": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /\$120,000-a-year hire at 30 percent utilization is not a \$4,000-a-month fractional architect at 100 percent/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-saas-mode-setup-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account that ships without the rebilling is a sub-account that bills the wrong amount/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-new-hire-onboarding-plan": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /hire who waits 30 days for the sub-account access is a hire who ships nothing in the first 60/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
